import { getLocalAccessToken } from "../../utils/helper";
import api from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.systemPermission;

export const createPermission = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      getPermissionDetail(response.data.data.id, (result) => {
        callback(result);
        Toast("success", "Thành công");
      });
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getPermissions = (params = {}, callback) => {
  api
    .get(URL, { params })
    .then((response) => {
      return callback(response.data.data);
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getPermissionDetail = (id, callback) => {
  api
    .get(`${URL}/${id}`)
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const createPermissionCRUD = (data, callback) => {
  api
    .post(`${URL}-crud`, data)
    .then((response) => {
      callback(response.data.data.listPermissionId);
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getPermissionsExceptionRoleId = (roleId, callback) => {
  api
    .get(`${URL}/exception-by-role?roleId=${roleId}`)
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
